//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import {
  useLazyQuickSearchQuery,
} from 'api/tickets'

import ModalFormContainer from 'components/Shared/ModalForm/Index'

const MoveTicketForm = ({
  visible, onSubmit, onClose, ticket,
}) => {
  const { t } = useTranslation()
  const [triggerQuickSearch] = useLazyQuickSearchQuery()

  const onLoadFunc = async (inputValue, callback) => {
    const data = await triggerQuickSearch({
      ticketingSystemDisplayId: ticket.ticketingSystemDisplayId,
      currentTicketNumber: ticket.externalId,
      canBeParent: true,
      searchTerm: inputValue,
    }).unwrap()

    const ticketValues = data.tickets?.map(item => ({
      value: item.id,
      shortLabel: item.number,
      label: `${item.number} ${item.title}`,
    })) || []

    callback(ticketValues)
  }

  const fieldParams = [{
    name: 'parentTicket',
    label: t('ticketPage.moveTicketForm.parentTicket'),
    type: 'selectAsync',
    placeholder: t('ticketPage.moveTicketForm.placeholder'),
    onLoadOptions: onLoadFunc,
    required: true,
  }]

  const initialValues = {
    'parentTicket': null,
  }

  return (
    <ModalFormContainer
      onClose={onClose}
      visible={visible}
      onSubmit={onSubmit}
      title={t('ticketPage.moveTicketForm.title')}
      fieldParams={fieldParams}
      initialValues={initialValues}
    />
  )
}

MoveTicketForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  ticket: PropTypes.object.isRequired,
}

export default MoveTicketForm
